export default ({ id, questions }) => ({
  id,
  questions: questions.map(({ question, answer, topics }) => ({
    question,
    answer,
    topics,
  })),
});
